import { getCustomerById, customerAllowsDemoFallback } from '../config/customers';
import { getResolvedCustomerId } from '../config/environment';
import { getCustomerFromCurrentHostname } from './customerFromHostname';
import { getSelectedCustomer } from './selectedCustomer';
import { isLocalhost } from './runtimeUrls';

function getActiveCustomer() {
  return (
    getCustomerFromCurrentHostname() ||
    getSelectedCustomer() ||
    getCustomerById(getResolvedCustomerId())
  );
}

/** Localhost dev always allows demo; production kommuner opt in via customers.json. */
export function isDemoFallbackAllowed() {
  if (isLocalhost()) {
    return true;
  }

  return customerAllowsDemoFallback(getActiveCustomer());
}

/**
 * Load Dataverse data, optionally falling back to demo data when allowed.
 * Set allowDemoFallback: true on a kommune in customers.json to enable on production.
 */
export async function loadDataverseWithDemoFallback(loadFn, loadDemoFn) {
  try {
    return { data: await loadFn(), source: 'dataverse' };
  } catch (error) {
    if (!isDemoFallbackAllowed()) {
      throw error;
    }

    console.warn('Dataverse unavailable, using demo data:', error);
    return { data: await loadDemoFn(), source: 'demo' };
  }
}

export const DEMO_DATA_BANNER_TEXT =
  'Viser demodata. Endringer lagres ikke i Dataverse.';
